module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Light.1f7c8be8.woff";